import * as ReactQuery from 'react-query';
import { UnwrapAsyncReturn } from '../../../utils/types/unwrap-promise';
import { QUERY_KEY_FUSION } from '../../../components/admin/fusion-process/fusion-process-utils';
import { getFusionApi } from './api';

export function useFetchFusion(params: {
  fusionId: string;
  onSuccess: (data: UnwrapAsyncReturn<typeof getFusionApi>) => void;
}) {
  return ReactQuery.useQuery(QUERY_KEY_FUSION(params.fusionId), getFusionApi, {
    onSuccess: params.onSuccess,

    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}
